import uniqueIds from '@/config/unique-ids.json'

const prodConfig = {
  getLoginUrl: {
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: (search: string) => `https://www.sh.smartedu.cn/digital-base/oauth2/authorize?openAppId=35cdb933-4873-457d-8b31-38d3cdeb4894&service=https://mapi.feixiangxingqiu.com/metis-oauth/api/shanghai/login/callback/7e8f30cc-5a52-4c60-8f97-4c6189d4698b${search}`,
  },
}

const testConfig = {
  getLoginUrl: {
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: (search: string) => `https://smileresource.shec.edu.cn/digital-base/oauth2/authorize?openAppId=0b018f68-e003-4a8d-a8e7-f23a7d73d534&service=https://mapi-pub.feixiangxingqiu.biz/metis-oauth/api/shanghai/login/callback/2a8ee233-1797-4489-b103-a99b26a44abd${search}`,
  },
}

const devConfig = {
  ...testConfig
}

const fedebugConfig = {
  ...testConfig
}

const ENV = process.env.REACT_APP_ENV

const result = (() => {
  switch (ENV) {
    case 'online':
      return prodConfig
    case 'development':
      return devConfig
    case 'fedebug':
      return fedebugConfig
    default:
      return testConfig
  }
})()

export const jumpConfig = result
